var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Notice"},[_c('div',{staticClass:"text"},[_vm._t("default")],2),(_vm.isClosable)?_c('Icon',{staticClass:"close",attrs:{"name":"cross"},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }